/*
 * @Author: jin.li 1754611189@qq.com
 * @Date: 2025-09-12 13:54:00
 * @LastEditors: jin.li 1754611189@qq.com
 * @LastEditTime: 2025-09-24 14:07:21
 * @FilePath: \cbest-welfare-erp-h5\src\@hooks\useFormDataGetPageDataByRequest.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState, useRef } from 'react'
const defaultPageData = {
  pageCount: 0,
  pageIndex: 1,
  pageSize: 10,
  recordCount: 0,
  result: []
}

export default function useFormDataGetPageDataByRequest(requst = () => {}) {
  const [pageData, setPageData] = useState(defaultPageData)
  const [loading, setLoading] = useState(false)
  const basicParams = useRef({})
  const getList = async (params = {}) => {
    setLoading(true)
    if (params && params.formData) {
      let formData = params.formData;
      // 统一处理空字符串
      (Object.keys(formData) || []).map(item => {
        if (formData[item] === '') formData[item] = null
      })
      basicParams.current = formData
    }
    try {
      let _listData = await requst({
        ...basicParams.current,
        pageIndex: params.pageIndex || 1,
        pageSize: params.pageSize || pageData.pageSize
      })
      setLoading(false)
      _listData && setPageData(_listData)
    } catch (error) {
      if (params && params.formData) setPageData(defaultPageData)
      setLoading(false)
    }
  }
  return {
    pageData,
    getList,
    loading
  }
}
